import { useForm } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'
import Heading from '@arianna/design-system/Heading'
import Text from '@arianna/design-system/Text'
import Input from '@arianna/design-system/Input'
import Button from '@arianna/design-system/Button'

interface Props {
  errors: Record<string, string>
  flash: Record<string, string>
}

export default function Login({ errors, flash }: Props) {
  const form = useForm({
    user: {
      email: '',
      password: '',
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/users/sign_in', {
      forceFormData: false,
    })
  }

  const errorMessage = errors.base ?? form.errors['user.email'] ?? form.errors['user.password']

  return (
    <AuthLayout>
      <Heading variant="h3" style={{ marginBottom: 'var(--space-1)' }}>
        Accedi
      </Heading>
      <Text
        variant="body"
        style={{ color: 'var(--ink-3)', display: 'block', marginBottom: 'var(--space-6)' }}
      >
        Entra nella tua libreria Arianna.
      </Text>

      {flash.notice && (
        <div
          style={{
            background: 'color-mix(in oklab, var(--accent) 10%, transparent)',
            border: '1px solid var(--accent)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
          }}
        >
          <Text variant="meta" style={{ color: 'var(--accent)', fontSize: 13 }}>
            {flash.notice}
          </Text>
        </div>
      )}

      {errorMessage && (
        <div
          style={{
            background: 'color-mix(in oklab, var(--red) 10%, transparent)',
            border: '1px solid var(--red)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
          }}
        >
          <Text variant="meta" style={{ color: 'var(--red)', fontSize: 13 }}>
            {errorMessage}
          </Text>
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
      >
        <Input
          label="Email"
          type="email"
          autoComplete="email"
          value={form.data.user.email}
          onChange={(e) => form.setData('user', { ...form.data.user, email: e.target.value })}
          required
        />
        <Input
          label="Password"
          type="password"
          autoComplete="current-password"
          value={form.data.user.password}
          onChange={(e) => form.setData('user', { ...form.data.user, password: e.target.value })}
          required
        />

        <Button
          type="submit"
          variant="primary"
          size="md"
          disabled={form.processing}
          style={{ width: '100%', marginTop: 'var(--space-2)' }}
        >
          {form.processing ? 'Accesso in corso…' : 'Accedi'}
        </Button>
      </form>

      <div
        style={{
          marginTop: 'var(--space-6)',
          paddingTop: 'var(--space-4)',
          borderTop: '1px solid var(--line)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-2)',
          textAlign: 'center',
        }}
      >
        <Text variant="meta" style={{ color: 'var(--ink-3)', fontSize: 13 }}>
          Non hai un account?{' '}
          <a href="/users/sign_up" style={{ color: 'var(--accent)', textDecoration: 'none' }}>
            Registrati
          </a>
        </Text>
        <Text variant="meta" style={{ color: 'var(--ink-3)', fontSize: 13 }}>
          <a
            href="/users/password/new"
            style={{ color: 'var(--ink-3)', textDecoration: 'underline' }}
          >
            Password dimenticata?
          </a>
        </Text>
      </div>
    </AuthLayout>
  )
}
